// src/pages/ThankYou.js
import React from 'react';

const ThankYou = () => (
  <div>
    <h1>Thank You!</h1>
    <p>Your transaction was successful.</p>
  </div>
);

export default ThankYou;
